import { render, staticRenderFns } from "./operatorCenter.vue?vue&type=template&id=04b32c55&scoped=true&"
import script from "./operatorCenter.vue?vue&type=script&lang=js&"
export * from "./operatorCenter.vue?vue&type=script&lang=js&"
import style0 from "./operatorCenter.vue?vue&type=style&index=0&id=04b32c55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b32c55",
  null
  
)

export default component.exports